// #154 (Paul 29.10.2026): Aufgaben nach Projekt, Kunde, Titel suchen.
// Die Liste liegt schon komplett im Browser (bis 500 Aufgaben) — gesucht wird
// darin, ohne neuen Server-Aufruf. Jedes Wort muss vorkommen; Umlaute zählen
// gleich („müller“ = „mueller“). Eine Zahl am Wortende muss dort auch enden:
// „SAN-534“ trifft nicht „SAN-5345“.

type Aufgabe = {
  title?: string | null
  comment?: string | null
  project_nr?: string | null
  project_title?: string | null
  contact_name?: string | null
  target_user_name?: string | null
}

function normal(s: string): string {
  return s
    .toLowerCase()
    .replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss")
    .normalize("NFD").replace(/[̀-ͯ]/g, "")
}

function enthaelt(text: string, wort: string): boolean {
  let ab = text.indexOf(wort)
  while (ab >= 0) {
    const danach = text.charAt(ab + wort.length)
    if (!/\d$/.test(wort) || !/\d/.test(danach)) return true
    ab = text.indexOf(wort, ab + 1)
  }
  return false
}

export function aufgabeTrifft(t: Aufgabe, suche: string): boolean {
  const woerter = normal(suche).split(/\s+/).filter(Boolean)
  if (!woerter.length) return true
  const text = normal([t.project_nr, t.project_title, t.contact_name, t.title, t.comment, t.target_user_name]
    .filter(Boolean).join(" \n "))
  return woerter.every((w) => enthaelt(text, w))
}
